export default __webpack_public_path__ + "static/media/time-add-rates.85f1c0ae.png";